/* eslint-disable jira/filename-case */

import { getMark } from '@atlassian/jira-common-performance/src/marks.tsx';
import { SPA_SSR_RENDERED } from '@atlassian/jira-providers-spa-apdex-analytics/src/constants.tsx';

export const getSSRMark = (): number | null => getMark(SPA_SSR_RENDERED)?.startTime || null;
